import type { ReactNode } from 'react'
import { PREFIXO_SELECIONAVEL } from '../camera/comandosCamera'

/**
 * Torna um ocupante clicável na cena.
 *
 * Em Cinemática e Extração a vítima era escolhida numa lista do painel, e não
 * tocando nela: o aluno via o corpo se mover e não tinha como perguntar "quem é
 * esse?" apontando. O nome do grupo é o mesmo padrão que as peças e os objetos
 * do Table top usam, de modo que "enquadrar seleção" também passa a funcionar.
 *
 * `stopPropagation` é necessário: sem ele o clique atravessa até o veículo e a
 * seleção salta para a peça que estiver atrás da vítima.
 */
export function OcupanteSelecionavel({
  id,
  aoSelecionar,
  children,
}: {
  id: string
  aoSelecionar?: (id: string) => void
  children: ReactNode
}) {
  return (
    <group
      name={`${PREFIXO_SELECIONAVEL}${id}`}
      onPointerDown={
        aoSelecionar
          ? (evento) => {
              evento.stopPropagation()
              aoSelecionar(id)
            }
          : undefined
      }
    >
      {children}
    </group>
  )
}
